import { useEffect } from "react";

const BASE_URL = "https://iinspire.my";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SeoHead = ({ title, description, path = "/", image, type = "website", jsonLd = [] }) => {
  useEffect(() => {
    const url = `${BASE_URL}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", image || `${BASE_URL}/og-image.jpg`);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image || `${BASE_URL}/og-image.jpg`);
    document.head.querySelectorAll("script[data-eco-jsonld]").forEach((el) => el.remove());
    jsonLd.filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-eco-jsonld", "1");
      s.textContent = JSON.stringify(obj);
      document.head.appendChild(s);
    });
  }, [title, description, path, image, type, JSON.stringify(jsonLd)]);
  return null;
};

export const articleJsonLd = ({ title, description, slug, basePath, author, date, image }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  url: `${BASE_URL}${basePath}/${slug}`,
  mainEntityOfPage: `${BASE_URL}${basePath}/${slug}`,
  author: { "@type": "Person", name: author || "Dr. Irma" },
  publisher: { "@type": "Organization", name: "iINSPIRE — Irma Ariandi" },
  ...(date ? { datePublished: date } : {}),
  ...(image ? { image: `${BASE_URL}${image}` } : {}),
});
